module.exports = __webpack_public_path__ + "img/ELMY_120X35.41c6daaa.png";